export default {
    methods: {
        async pdf_post_datatable(payload) {
            const pdf = await this.POST("PDF/Datatable", payload);
            this.open_pdf_tab(pdf);
        },

        async pdf_get_relatorio(payload) {
            const pdf = await this.GET(`/PDF/Relatorio/${payload}`);
            this.open_pdf_tab(pdf);
        },

        open_pdf_tab(pdf) {
            /*const pdfWindow = window.open("", "_blank")
            if(pdfWindow){
                pdfWindow.document.write("<iframe width='100%' height='99%' src='data:application/pdf;base64, " + pdf + "'></iframe>")
            }*/
            const link = document.createElement("a");
                link.download = "relatorio.pdf";
                link.href = "data:application/pdf;base64, " + pdf ;
                link.click();
        }
    }
}